const en = {
    "home":{
        "name": "home",
        "url":"/",
        "title": "LEVTY",
        "description": "Specialized teams to drive the digital transformation of your organization. Create development teams to accelerate your project construction and launch high-quality digital products."
    },

    "specializedTeams": {
        "title": "Teams specialized in digital transformation",
        "description": "Teams of qualified professionals on a corporate digital platform who work with dedication as part of your organization."
    },

    "teamAsService":{
        "title": "Team as a service",
        "description": "We provide your organization with one or more teams of software engineers trained on a digital platform to meet your requirements."
    },

    "management":{
        "title": "Management and flexibility",
        "description": "Our teams adopt a specialized methodology, online tools to manage agile projects and communication through chat, landline and email.",
        "features":[
            {
                "title":"Productivity",
                "description":"Our development team uses agile methodologies, ensuring the efficiency of deliveries."
            },
            {
                "title":"Cost predictability",
                "description":"Custom plans according to the profile of your organization."
            },
            {
                "title":"Scalable team",
                "description":"Assemble multidisciplinary teams to build and publish quality projects."
            },
            {
                "title":"Qualified professionals",
                "description":"Experienced teams of software engineers will work exclusively on your project."
            },
            {
                "title":"Transparency",
                "description":"Track deliveries, backlog visibility, and status through a direct communication channel."
            },
            {
                "title":"Talent retention",
                "description":"Our professionals are chosen with discretion and we offer different advantages so that they are fully involved in your project."
            }
        ]
    },

    "teamsModels":{
        "title": "Team models for every business scale",
        "description": "Our team models include, in addition to the software development team, the Unit Director and the Account Manager.",
        "packs": [
            {
                "title":"Minimum",
                "description": "2 Software Engineers",
                "scrum": "1 Scrum Master / Product Owner / Development Leader",
                "dev": "1 Developer"
            },
            {
                "title":"Basic",
                "description": "3 Software Engineers",
                "scrum": "1 Scrum Master / Product Owner",
                "devLead": "1 Development Leader",
                "dev":"1 Developer"
            },
            {
                "title":"Full",
                "description": "5 Software Engineers",
                "scrum": "1 Scrum Master / Product Owner",
                "devLead": "1 Development Leader",
                "dev":"3 Developers"
            }
        ]
    },

    "ourTechnology":{
        "title": "Our Technology",
        "description": "We are official SYDLE partners, specialized in the SYDLE ONE platform, including its solutions.",
        "bpm":"BPM",
        "ecm":"ECM",
        "crm":"CRM",
        "billing":"Billing",
        "ecommerce":"E-commerce",
        "servicedesk":"Service Desk / ITSM",
        "powerManagement":"Power Management",
        "analytics":"Analytics",
        "learnMore":"Learn more"
    },

    "buildTeam":{
        "title": "Build a team for your organization",
        "description": "Count on our flexibility to design cohesive teams based on your goals and needs. Contact us for more information."
    },
    
    "button":{
        "plans":"Plans",
        "contact":"Get in touch",
        "learnMore":"Learn More"
    },

    "customers": {
        "title": "Meet our customers",
        "description": "Companies that trust LEVTY's teams of experts in digital transformation."    
    }
}
export default en